import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import localeHr from '@angular/common/locales/hr';
import localeHrExtra from '@angular/common/locales/extra/hr';
import moment from 'moment';
import 'moment/locale/hr';

moment.locale('hr');

registerLocaleData(localeHr, 'hr', localeHrExtra);

bootstrapApplication(AppComponent, appConfig)
    .catch((err) => console.error(err));